module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Strike-Back-S7.70bb207.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Strike-Back-S7.jpg
// module id = 7Qrv
// module chunks = 0